<template>
  <v-form ref="form">
    <v-card>
      <v-card-title class="font-weight-bold"> Alterar Senha</v-card-title>
      <v-card-text>
        <v-row class="mt-0">
          <v-col v-if="msgErro != ''" cols="12" class="pa-0">
            <v-alert class="mb-0" type="error" text>{{ msgErro }}</v-alert>
          </v-col>
          <v-col cols="12" class="mt-2"
            ><v-text-field
              label="Senha atual*"
              type="password"
              v-model="senhaAtual"
              :rules="senhaAtualRules"
              required
            ></v-text-field
          ></v-col>
          <v-col cols="12"
            ><v-text-field
              label="Nova senha*"
              type="password"
              v-model="novaSenha"
              :rules="novaSenhaRules"
              required
            ></v-text-field
          ></v-col>
          <v-col cols="12"
            ><v-text-field
              label="Confirmar senha"
              type="password"
              v-model="confirmarSenha"
              :rules="confirmarNovaSenhaRules"
              required
            ></v-text-field
          ></v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="success"
          rounded
          min-width="120"
          @click="alterarSenha"
          :loading="atualizandoSenha"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    msgErro: "",
    senhaAtual: "",
    novaSenha: "",
    confirmarSenha: "",
    atualizandoSenha: false,
    senhaAtualRules: [(v) => !!v || "Informe a senha atual"],
    novaSenhaRules: [
      (v) => !!v || "Informe a nova senha",
      (v) => (v && v.length >= 6) || "Senha deve conter no mínimo 6 caracteres",
    ],
    confirmarNovaSenhaRules: [(v) => !!v || "Informe a senha de confirmação"],
  }),
  methods: {
    async alterarSenha() {
      this.msgErro = "";
      if (this.novaSenha != this.confirmarSenha) {
        this.msgErro = "Senha de confirmação não corresponde com a nova senha";
        return;
      }

      if (this.$refs.form.validate()) {
        this.atualizandoSenha = true;
        await axios
          .post(`colaborador/alterar-senha`, {
            senha_atual: this.senhaAtual,
            nova_senha: this.novaSenha,
            nova_senha_confirmacao: this.confirmarSenha,
          })
          .then((res) => {
            if (res.data.success) {
              this.$refs.form.reset();
              this.$toasted.success("Senha atualizada com sucesso!", {
                duration: 3000,
              });
              this.dialog = false;
            } else this.msgErro = res.data.msg;
          })
          .catch(
            (e) => (this.msgErro = `Houve um erro ao atualizar a senha. ${e}`)
          );
        this.atualizandoSenha = false;
      }
    },
  },
};
</script>
